import React, { useEffect, useContext } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

import { START_TOUCH } from '@confluence/navdex/entry-points/NavdexPointType.ts';
import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component.ts';
import { HOME_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';

import { useSelectedView } from './useSelectedView.ts';
import { View } from './homeRouteParams.ts';
import { ForYou, Recent, Drafts, Starred, Tasks } from './HomeViews/index.ts';

export const HomeMainContentArea = (): React.JSX.Element => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const selectedView = useSelectedView();
	const experienceTracker = useContext(ExperienceTrackerContext);

	useEffect(() => {
		createAnalyticsEvent({
			type: 'sendTrackEvent',
			data: {
				action: 'viewed',
				actionSubject: `${selectedView}Screen`,
				source: 'homeScreen',
				attributes: {
					navdexPointType: START_TOUCH,
				},
			},
		}).fire();
	}, [selectedView, createAnalyticsEvent]);

	switch (selectedView) {
		case View.RECENT:
			return <Recent />;
		case View.STARRED:
			return <Starred />;
		case View.DRAFTS:
			return <Drafts />;
		case View.TASKS:
			/**
			 * We don't want the task home experience to impact Home. This will consider the Home experience as complete
			 * for the purposes of the loading indicator underneath the main navigation bar.
			 */
			experienceTracker.succeed({
				name: HOME_EXPERIENCE,
			});
			return <Tasks />;
		case View.OVERVIEW:
		default:
			return <ForYou />;
	}
};
